import React from 'react';
import classes from './Wrapper_trade.module.css';

const Wrapper_trade = (props) => (
<div className={classes.Wrapper_trade}>

{props.children}

</div>

);

export default Wrapper_trade;